import { render } from "./RegistrationComp.vue?vue&type=template&id=2c1bd198"
import script from "./RegistrationComp.vue?vue&type=script&lang=js"
export * from "./RegistrationComp.vue?vue&type=script&lang=js"

import "./RegistrationComp.vue?vue&type=style&index=0&id=2c1bd198&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__